import { make } from "../src/common/PageForgotPassword.bs.js";
export default make;
